import { z } from 'zod';

export const schemaConsorsGermanTaxIdentifier = z
    .string()
    .min(11)
    .max(11)
    .regex(/^[0-9]+$/, 'Invalid characters');
